import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { settingsApi } from '../../api/lib/settings';
import { gdprKeys } from '../../api/query-keys/gdpr';
import { Gdpr, GdprClauseByType, GdprClauseType, GdprLanguage } from '../../api/types/gdpr';

export const useGDPRClause = () => {
  return useQuery<Gdpr[], ApiError, GdprClauseByType>({
    queryKey: gdprKeys.list(),
    queryFn: settingsApi.fetchGdprClauses,
    select: data => {
      const gdprClausesByType = {
        [GdprClauseType.GUEST]: Object?.values(GdprLanguage)?.map(language => ({
          createdAt: '',
          gdprClause: '',
          language,
          type: GdprClauseType.GUEST,
          updatedAt: '',
        })),
        [GdprClauseType.NEW_USER]: Object?.values(GdprLanguage)?.map(language => ({
          createdAt: '',
          gdprClause: '',
          language,
          type: GdprClauseType.NEW_USER,
          updatedAt: '',
        })),
      };

      data?.forEach(clause => {
        const foundGDPRIndex = gdprClausesByType[clause.type]?.findIndex(
          clauseByType => clauseByType.language === clause.language,
        );

        if (foundGDPRIndex !== -1) {
          gdprClausesByType[clause.type][foundGDPRIndex] = clause;
        }
      });

      return gdprClausesByType;
    },
  });
};
